import React from 'react';
import { brand } from '../../data/palette';
import type { Choice } from '../../types/filtek';
interface PillChoicesProps {
  choices: Choice[];
  selected?: string;
  accent?: string;
  onSelect: (choice: Choice) => void;
  size?: 'md' | 'lg';
}

/** Lightweight confirmation choices — deliberately low-effort to answer. */
export function PillChoices({
  choices,
  selected,
  accent = brand.green,
  onSelect,
  size = 'md'
}: PillChoicesProps) {
  return <div className="flex flex-wrap gap-3" data-id="element-422" data-mp="d8sbqbu01vfa">
      {choices.map(choice => {
      const isSelected = selected === choice.id;
      return <button key={choice.id} type="button" onClick={() => onSelect(choice)} aria-pressed={isSelected} className={`group rounded-full border font-light transition-all duration-500 ${size === 'lg' ? 'px-7 py-3.5 text-lg' : 'px-5 py-2.5 text-base'} ${isSelected ? 'border-transparent text-ink' : 'border-enamel/20 text-enamel hover:border-enamel/50 hover:bg-enamel/[0.04]'}`} style={isSelected ? {
        backgroundColor: accent,
        color: brand.ink
      } : undefined} data-id="element-423" data-mp="3g4ghlio3zio">
            {choice.label}
          </button>;
    })}
    </div>;
}